import AdminAddWorker from './AdminAddWorker';

export default AdminAddWorker;
